import { Component, OnInit } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { list } from 'aws-amplify/storage';
import { DataItem } from '../../models/data-ingestion';

@Component({
  selector: 'app-file-list',
  templateUrl: './file-list.component.html',
  styleUrl: './file-list.component.scss',
})
export class FileListComponent implements OnInit {
  fileList: any;
  isLoading?: boolean;
  headers: any[] = [
    {
      name: 'Name',
      sortOrder: null,
      sortFn: (a: DataItem, b: DataItem) => a.key.localeCompare(b.key),
      sortDirections: ['ascend', 'descend', null],
    },
    {
      name: 'Uploaded On',
      sortOrder: 'descend',
      sortFn: (a: DataItem, b: DataItem) => a.lastModified - b.lastModified,
      sortDirections: ['descend', null],
    },
    {
      name: 'File Size',
      sortOrder: 'descend',
      sortFn: (a: DataItem, b: DataItem) => a.size - b.size,
      sortDirections: ['ascend', 'descend', null],
    },
  ];

  constructor(private nzMessageService: NzMessageService) {}

  ngOnInit() {
    this.getFileList();
  }

  getFileList(): void {
    this.isLoading = true;
    list({
      path: ({ identityId }) => `private/${identityId}/`,
    })
      .then((results) => {
        this.fileList = results;
      })
      .catch(() => {
        this.nzMessageService.error('You are not authorized to perform this action. Please contact admin');
      })
      .finally(() => (this.isLoading = false));
  }
}
